import React from "react";

export default function PolicySection({ title, paragraphs }) {
  return (
    <div className="policy-section">
      <h3>{title}</h3>
      {paragraphs.map((p, i) => (
        <p key={i}>{p}</p>
      ))}
    </div>
  );
}
